import QuotationStatusBadge from '#/modules/crmMgmt/quotation/components/QuotationStatusBadge';
import {
  formatQuotationCustomer,
  formatQuotationRoundingMode,
  formatQuotationTotal,
} from '#/modules/crmMgmt/quotation/helper/quotationFormat';
import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

export const quotationSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {row?.status
            ? <QuotationStatusBadge status={row.status} size="sm" />
            : <p>-</p>}
        </div>
      ),
    },
  ],
};

export const quotationSideMsgDetailBlock = {
  fields: [
    { label: '報價單號', value: 'quotationNo' },
    { label: '客戶', value: (row) => formatQuotationCustomer(row?.customer) },
    { label: '聯絡人', value: (row) => dash(row?.contactName) },
    { label: '聯絡電話', value: (row) => dash(row?.contactPhone) },
    { label: '付款條件', value: (row) => dash(row?.paymentTermName) },
    { label: '有效截止日', value: (row) => formatDateOrDash(row?.validUntil) },
    { label: '總額取整', value: (row) => formatQuotationRoundingMode(row?.roundingMode) },
    { label: '總額（含稅）', value: (row) => formatQuotationTotal(row?.amountSummary?.totalAmount) },
    { label: '主項目數', value: (row) => (row?.lines ?? []).length },
    { label: '建立時間', value: (row) => formatDateTimeOrDash(row?.record?.createdAt) },
    { label: '內部備註', value: (row) => dash(row?.remark) },
  ],
};
